import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OpportunityTagsComponent } from './opportunity-tags.component';
import { AddTagsDialogComponent } from './add-tags-dialog/add-tags-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyTagsModule } from '@vendasta/galaxy/tags';
import { ReactiveFormsModule } from '@angular/forms';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatChipsModule,
    MatDialogModule,
    MatIconModule,
    GalaxyEmptyStateModule,
    GalaxyFormFieldModule,
    GalaxyLoadingSpinnerModule,
    GalaxyTagsModule,
  ],
  declarations: [OpportunityTagsComponent, AddTagsDialogComponent],
  exports: [OpportunityTagsComponent],
})
export class OpportunityTagsModule {}
